import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/index';
import { layerLink } from '../../layerGroup/link';

function createRemoveItem(delCube: CubeId): RemoveHistoryItem {
    let parent: CubeId = CubeTree.findParentIdByCubeId(delCube);
    let nextCube: CubeId|null = getNextCube(delCube);
    let cubeData: CubeTreeData = CubeTree.getCubeTreeData(delCube);

    return {
        parent,
        cubeData,
        before: nextCube
    };
}

// 需要考虑跨层板组件
function getNextCube(target: CubeId): CubeId|null {
    let nextCube: CubeId|null = CubeTree.findNextCube(target);

    if (!CubeTree.isGoods(target)
        && !CubeTree.isTextarea(target)
        && !CubeTree.isBafflePlate(target)) {
        return nextCube;
    }

    if (CubeTree.isInStage(target)) {
        return nextCube;
    }

    let itsLayer: CubeId = CubeTree.findCubeLayer(target);
    let grouped: boolean = UIToolkit.layerIsGrouped(itsLayer);

    if (UIToolkit.layoutType(itsLayer) === '|-|--|---') {
        return nextCube;
    }

    if (!grouped) {
        return nextCube;
    }

    if (nextCube) {
        return nextCube;
    }

    let link: LinkedListInstance|null = layerLink(itsLayer);
    let behindLinkLayers: CubeId[] = link.behindOf(itsLayer);
    let behindCubes: CubeId[] = CubeTree.findParentsChild(behindLinkLayers);

    if (behindCubes.length) {
        return behindCubes[0];
    }

    return null;
}

export {
    createRemoveItem
};
